import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { MaterialModule } from './material.module';

import { FlexLayoutModule } from '@angular/flex-layout';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component'; 
import { HttpClientModule } from '@angular/common/http';
import { MenucardComponent } from './menucard/menucard.component';
import { MenuCardsComponent } from './menu-cards/menu-cards.component';

import { IServiceFactory, ServiceFactory } from './Services/service-factory';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ELearningDashboardComponent } from './elearning-menu/elearning-dashboard/elearning-dashboard.component';
import { ElearningdashClassViewComponent } from './elearning-menu/elearningdash-class-view/elearningdash-class-view.component';
import { TeacherSearchAutofillComponent } from './Services/insertable-components/teacher-search-autofill/teacher-search-autofill.component';
import { ElearningdashClassmgmtDialogComponent } from './elearning-menu/elearningdash-classmgmt-dialog/elearningdash-classmgmt-dialog.component';

import { SpinnerComponent } from './spinner/spinner.component';
import { SpinnerWildComponent } from './Spinners/spinner-wild/spinner-wild.component';
import { SpinnerFaComponent } from './Spinners/spinner-fa/spinner-fa.component';
import { StudentFilterComponent } from './elearning-menu/student-filter/student-filter.component';
import { ElearningdashStudentViewComponent } from './elearning-menu/elearningdash-student-view/elearningdash-student-view.component';

import { NotificationBadgeComponent } from './notification-badge/notification-badge.component';
import { IAPIService } from './Services/API-Service/IAPIService';
import { StudentLessonMainComponent } from './Student-Lesson/StudentLesson-Main/student-lesson-main/student-lesson-main.component';
import { ZeroLessonsComponent } from './Student-Lesson/ZeroLessons/zero-lessons/zero-lessons.component';
import { ChooseLessonsComponent } from './Student-Lesson/ChooseLesson/choose-lessons/choose-lessons.component';
import { CollapseExpandAllClassesComponent } from './elearning-menu/collapse-expand-all-classes/collapse-expand-all-classes.component';
import { AssignmentComponent } from './layouts/CSA/assignment/assignment.component';
import { StudentCardComponent } from './layouts/CSA/assignment/assignment-panel/student-card/student-card.component';
import { ClassComponent } from './layouts/CSA/class/class.component';
import { FilterComponent } from './layouts/CSA/shared/filter/filter.component';
import { GradeDialogComponent } from './layouts/CSA/shared/grade-dialog/grade-dialog.component';
import { ReassignDialogComponent } from './layouts/CSA/shared/reassign-dialog/reassign-dialog.component';
import { ReleaseAllDialogComponent } from './layouts/CSA/shared/release-all-dialog/release-all-dialog.component';
import { AssignmentCardComponent } from './layouts/CSA/student/assignment-card/assignment-card.component';
import { StudentComponent } from './layouts/CSA/student/student.component';
import { DatePipe } from '@angular/common';
import { DiagnosticsDashboardComponent } from './layouts/diagnostics/dashboard/dashboard.component';
import { ClassPanelComponent } from './layouts/diagnostics/dashboard/class-panel/class-panel.component';
import { DiagnosticDetailComponent } from './layouts/diagnostics/diagnostic-detail/diagnostic-detail.component';
import { StudentPanelComponent } from './layouts/diagnostics/diagnostic-detail/student-panel/student-panel.component';
import { AssignmentCardBriefComponent } from './layouts/diagnostics/diagnostic-detail/student-panel/assignment-card-brief/assignment-card-brief.component';
import { SelectDiagnosticsDialogComponent } from './layouts/diagnostics/dashboard/class-panel/select-diagnostics-dialog/select-diagnostics-dialog.component';
import { ConfirmDialogComponent } from './layouts/shared/confirm-dialog/confirm-dialog.component';
import { SkippedStudentsDialogComponent } from './layouts/diagnostics/diagnostic-detail/skipped-students-dialog/skipped-students-dialog.component';
import { AssignLessonsDialogComponent } from './layouts/diagnostics/diagnostic-detail/assign-lessons-dialog/assign-lessons-dialog.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AssignmentPanelComponent } from './layouts/CSA/assignment/assignment-panel/assignment-panel.component';
import { ToastrModule } from 'ngx-toastr';
import { ViewWorkPageComponent } from './layouts/view-work/view-work-page/view-work-page.component';
import { QuestionGradingComponent } from './layouts/view-work/question-components/question-grading/question-grading.component';
import { MultipleChoiceComponent } from './layouts/view-work/question-components/multiple-choice/multiple-choice.component';
import { ShortAnswerComponent } from './layouts/view-work/question-components/short-answer/short-answer.component';
import { EssayComponent } from './layouts/view-work/question-components/essay/essay.component';
import { FilterQuestionsComponent } from './layouts/view-work/question-components/filter-questions/filter-questions.component';
import { FactComponent } from './layouts/view-work/question-components/fact/fact.component';
import { UnassignDiaglogComponent } from './layouts/CSA/shared/unassign-diaglog/unassign-diaglog.component';
import { DiagExamListDialogComponent } from './layouts/diagnostics/diagnostic-detail/diag-exam-list-dialog/diag-exam-list-dialog.component';
import { AdvanceAssignDialogComponent } from './layouts/CSA/shared/advance-assign-dialog/advance-assign-dialog.component';
import { CreateAccountComponent } from './layouts/create-account/create-account.component';
import { CurriculumListComponent } from './layouts/curriculum/curriculum-list/curriculum-list.component';
import { CurriculumRegisterComponent } from './layouts/curriculum/curriculum-register/curriculum-register.component';
import { RegisterDialogComponent } from './layouts/curriculum/register-dialog/register-dialog.component';
import { StudentCourseComponent } from './layouts/curriculum/student-course/student-course.component';
import { CurriculumViewComponent } from './layouts/curriculum/curriculum-view/curriculum-view.component';
import {OrderByPipe} from './pipes/order-by.pipe';
import { CurriculumViewDetailsDialogComponent } from './layouts/curriculum/curriculum-view-details-dialog/curriculum-view-details-dialog.component';
import { ProductLevelPickerComponent } from './layouts/curriculum/curriculum-register/product-level-picker/product-level-picker.component';
import { CurriculumPaymentSuccessComponent } from './curriculum-payment-results/curriculum-payment-success/curriculum-payment-success.component';
import { CurriculumPaymentFailureComponent } from './curriculum-payment-results/curriculum-payment-failure/curriculum-payment-failure.component';
import { NumberToCurrencyPipe } from './pipes/number-to-currency.pipe';
import { ConsumerCurriculumLoginComponent } from './consumer-curriculum-login/consumer-curriculum-login.component';
import { ConsumerCurriculumRegistrationStepsComponent } from './layouts/curriculum/consumer-curriculum-registration-steps/consumer-curriculum-registration-steps.component';
import { ConsumerCurriculumDemoReportComponent } from './layouts/curriculum/consumer-curriculum-demo-report/consumer-curriculum-demo-report.component';
import { ConsumerCurriculumDiagnosticMarketingComponent } from './layouts/curriculum/consumer-curriculum-diagnostic-marketing/consumer-curriculum-diagnostic-marketing.component';
import { SimplePopupDialogComponent } from './simple-popup-dialog/simple-popup-dialog.component';
import { CurriculumStandardsCourseReportComponent } from './layouts/curriculum/curriculum-standards-course-report/curriculum-standards-course-report.component';
import { CurriculumRegisterParentPasswordComponent } from './layouts/curriculum/curriculum-register/curriculum-register-parent-password/curriculum-register-parent-password.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { EmailConfirmationComponent } from './layouts/curriculum/email-confirmation/email-confirmation.component';
import { StandardsGrowthPopupComponent } from './layouts/curriculum/curriculum-standards-course-report/standards-growth-popup/standards-growth-popup.component';
import { AssignmentAttemptsViewWorkDialogComponent } from './layouts/view-work/assignment-attempts-view-work-dialog/assignment-attempts-view-work-dialog.component';



@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    ElearningdashClassViewComponent,
    TeacherSearchAutofillComponent,
    ElearningdashClassmgmtDialogComponent,
    ELearningDashboardComponent,
    ElearningdashStudentViewComponent,
    StudentFilterComponent,
    SpinnerFaComponent,
    SpinnerWildComponent,
    MenucardComponent,
    MenuCardsComponent,
    NotificationBadgeComponent,
    StudentLessonMainComponent,
    ZeroLessonsComponent,
    ChooseLessonsComponent,
    CollapseExpandAllClassesComponent,

    ClassComponent,
    AssignmentComponent,
    StudentCardComponent,
    StudentComponent,
    AssignmentCardComponent,
    GradeDialogComponent,
    FilterComponent,
    ReassignDialogComponent,
    ReleaseAllDialogComponent,
    DiagnosticsDashboardComponent,
    ClassPanelComponent,
    DiagnosticDetailComponent,
    StudentPanelComponent,
    AssignmentCardBriefComponent,
    SelectDiagnosticsDialogComponent,
    ConfirmDialogComponent,
    SkippedStudentsDialogComponent,
    AssignLessonsDialogComponent,
    AssignmentPanelComponent,
    ViewWorkPageComponent,
    SafeHtmlPipe,
    QuestionGradingComponent,
    MultipleChoiceComponent,
    ShortAnswerComponent,
    EssayComponent,
    FilterQuestionsComponent,
    FactComponent,
    UnassignDiaglogComponent,
    DiagExamListDialogComponent,
    AdvanceAssignDialogComponent,
    CreateAccountComponent,
    CurriculumListComponent,
    CurriculumRegisterComponent,
    RegisterDialogComponent,
    StudentCourseComponent,
    CurriculumViewComponent,
    OrderByPipe,
    NumberToCurrencyPipe,
    CurriculumViewDetailsDialogComponent,
    ProductLevelPickerComponent,
    CurriculumPaymentSuccessComponent,
    CurriculumPaymentFailureComponent,
    ConsumerCurriculumLoginComponent,
    ConsumerCurriculumRegistrationStepsComponent,
    ConsumerCurriculumDemoReportComponent,
    ConsumerCurriculumDiagnosticMarketingComponent,
    SimplePopupDialogComponent,
    CurriculumStandardsCourseReportComponent,
    CurriculumRegisterParentPasswordComponent,
    EmailConfirmationComponent,
    StandardsGrowthPopupComponent,
    AssignmentAttemptsViewWorkDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexLayoutModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      closeButton: true
    }),
    MatExpansionModule
  ],
  providers: [
    { provide: IServiceFactory, useClass: ServiceFactory },
    { provide: IAPIService, useClass: environment.IAPIService },
    { provide: MAT_DATE_LOCALE,useValue: 'en-US' },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
